import React from 'react'

function EventTypeWelcome() {
    return (
        <div>
            Willkommensnachricht / Erklärung folgt...
        </div>
    )
}

export default EventTypeWelcome
